const safeLinks = function() {
  let links = document.links;
  if (links.length) {
      Array.prototype.forEach.call(links, link => {
          if (link.hostname != window.location.hostname) {
              link.target = "_blank";
              link.setAttribute("rel", "noopener noreferrer");
              link.classList.add("externalLink");
          } else {
              link.classList.add("localLink");
          }
      });
  }
};

const smoothScroll = () => {
  const anchors = document.querySelectorAll('a[href^="#"]');
  if (!anchors) return;
  anchors.forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();

      let href = this.getAttribute('href');
      if (href.length < 2) return false

      document.querySelector(this.getAttribute('href')).scrollIntoView({
        behavior: 'smooth'
      });
    });
  });
};

window.get_cookie = function(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];

    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }

    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }

  return "";
};

// pass expiry in minutes
window.set_cookie = function(cname, cvalue, expiry) {
  let date = new Date();
  date.setTime(date.getTime() + (expiry * 1000 * 60));
  let expires = "expires=" + date.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};

window.delete_cookie = function(cname) {
  window.set_cookie(cname, null, -1);
};

window.has_cookie = function(cname) {
  return window.get_cookie(cname) !== '';
};

export { safeLinks, smoothScroll };
